import { Center, Flex, Text, useToast } from '@chakra-ui/react';
import { PeOrderListItem } from 'model/modules/pe/orders/peOrderList';
import { FC } from 'react';
import PeSelfOrdersGridItem from 'presentation/components/modules/pe/selfOrders/PeSelfOrderGridItem';
import AppCard from 'presentation/components/shared/card/AppCard';
import { useTranslation } from 'react-i18next';
import { useCancelPeOrderDetailMutation } from 'rtkQuery/sharespro/queries/peService';
import FullScreenLoader from 'presentation/components/shared/FullScreenLoader';
import useToastError from 'hooks/shared/useToastError';

interface Props {
  orders: PeOrderListItem[];
  assetId: ID;
}

const PeDetailOrders: FC<Props> = ({ orders, assetId }) => {
  const { t } = useTranslation();

  const [cancelOrder, { isLoading }] = useCancelPeOrderDetailMutation();

  const gapBetweenCards = 20;

  const toast = useToast();
  const toastErrorHandler = useToastError();

  if (orders.length === 0) {
    return (
      <AppCard p="20px">
        <Center>
          <Text>{t('listIsEmpty')}</Text>
        </Center>
      </AppCard>
    );
  }

  return (
    <>
      <Flex flexWrap="wrap" justifyContent="space-between">
        {orders.map((order) => (
          <PeSelfOrdersGridItem
            disableNavigating
            key={order.id}
            showHeader={false}
            peOrder={order}
            w={`calc(50% - ${gapBetweenCards / 2}px)`}
            mb={`${gapBetweenCards}px}`}
            onCancelClick={() => {
              cancelOrder({
                orderId: order.id,
                assetId,
              })
                .then(() => {
                  toast({
                    description: t('orderWasCanceled'),
                    status: 'success',
                    position: 'top-right',
                    isClosable: true,
                  });
                })
                .catch(toastErrorHandler);
            }}
          />
        ))}
      </Flex>
      <FullScreenLoader isLoading={isLoading} />
    </>
  );
};

export default PeDetailOrders;
